import round from 'lodash/round'
import * as R from 'ramda'

export const to_mb = R.compose(

    // Punkt durch Komma ersetzen
    R.pipe(String, R.replace('.', ',')),

    // auf 2 Stellen runden
    size => round(size, 2),

    // in MB umrechnen
    size => size / 1024 / 1204

)
